module.exports = __webpack_public_path__ + "media/1.246ae1ff.mp3";